import { useOrganization } from "@/queries/organizations";
import { useCurrentUser } from "@/queries/users";

import { useWorkspaces } from "@/queries";
import useActiveWorkspace from "./useActiveWorkspace";

const useActiveOrganization = () => {
  const activeWorkspace = useActiveWorkspace();
  const organization = useOrganization(activeWorkspace?.organization_id!);
  return organization.data;
};

const useIsOrgOwner = () => {
  const activeOrg = useActiveOrganization();
  const currentUser = useCurrentUser();
  return (
    currentUser.data?.memberships.organizations.find(
      (org) => org.organization_id === activeOrg?.id,
    )?.is_owner || false
  );
};

const useActiveOrgWorkspaces = () => {
  const workspaces = useWorkspaces();
  const activeOrg = useActiveOrganization();
  return (
    workspaces.data?.workspaces.filter(
      (workspace) => workspace.organization_id === activeOrg?.id,
    ) || []
  );
};

export { useActiveOrganization, useActiveOrgWorkspaces, useIsOrgOwner };
